import { css } from 'styled-components';
import { colorCSS } from './colors';
export const components = css `
  .tooltip-content {
    a {
      color: ${colorCSS('N0')};
    }
    p {
      margin-bottom: 0.5rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
//# sourceMappingURL=components.js.map